let SampleReportData = {
/*    "data": [
        {
            "point": {
                "id": "82dbc29722e54ba8afcb38fde1eaa07d",
                "cid": "NZ",
                "lat": -37.6918,
                "lon": 176.1678,
                "name": "Bad 2"
            },
            "historicalData": [
                {
                    "values": [
                        98.819999694824219,
                        123.15000152587891,
                        139.38999938964844,
                        150.92999267578125,
                        117.83999633789062,
                        97.580001831054688,
                        59.5099983215332,
                        37.060001373291016,
                        24.079999923706055
                    ],
                    "varid": "ped",
                    "units": "mm",
                    "name": "Precipitation Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        104.5,
                        87.129997253417969,
                        123.51000213623047,
                        91.6500015258789,
                        97.139999389648438,
                        121.83000183105469,
                        135.21000671386719,
                        122.91999816894531,
                        139.14999389648438
                    ],
                    "varid": "pr",
                    "units": "mm",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        -9999.0,
                        15.460000038146973,
                        17.569999694824219,
                        19.030000686645508,
                        19.260000228881836,
                        17.809999465942383,
                        15.380000114440918,
                        12.840000152587891,
                        10.649999618530273
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        -9999.0,
                        -9999.0,
                        -9999.0,
                        -9999.0,
                        -9999.0,
                        -9999.0,
                        -9999.0,
                        -9999.0,
                        -9999.0
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed",
                    "varGroup": "wind"
                }
            ],
            "forecastData": [
                {
                    "values": [
                        -3.1700000762939453,
                        -9.34000015258789,
                        -29.600000381469727,
                        -9.0299997329711914,
                        -19.510000228881836,
                        -29.75,
                        1.0099999904632568,
                        7.2600002288818359,
                        11.619999885559082
                    ],
                    "varid": "ped",
                    "units": "mm/month",
                    "name": "Potential Evapotranspiration Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        -3.1400001049041748,
                        -10.859999656677246,
                        -24.6200008392334,
                        -10.630000114440918,
                        -18.530000686645508,
                        -27.989999771118164,
                        0.67000001668930054,
                        4.7399997711181641,
                        8.2100000381469727
                    ],
                    "varid": "pr_p",
                    "units": "%",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        -0.37999999523162842,
                        -0.25999999046325684,
                        -0.25999999046325684,
                        -0.090000003576278687,
                        0.37999999523162842,
                        0.79000002145767212,
                        0.52999997138977051,
                        0.5899999737739563,
                        0.23000000417232513
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature anomaly",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        1.4199999570846558,
                        0.93999999761581421,
                        0.67000001668930054,
                        0.070000000298023224,
                        0.18000000715255737,
                        0.62999999523162842,
                        0.41999998688697815,
                        0.2800000011920929,
                        0.4699999988079071
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed anomaly",
                    "varGroup": "wind"
                }
            ]
        },
        {
            "point": {
                "id": "a8d2da138471400d947fd02cc93a7d6c",
                "cid": "NZ",
                "lat": -38.0829,
                "lon": 175.7586,
                "name": "New point"
            },
            "historicalData": [
                {
                    "values": [
                        89.339996337890625,
                        112.54000091552734,
                        127.48999786376953,
                        138.94999694824219,
                        110.01000213623047,
                        90.870002746582031,
                        54.200000762939453,
                        31.950000762939453,
                        20.459999084472656
                    ],
                    "varid": "ped",
                    "units": "mm",
                    "name": "Precipitation Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        119.44999694824219,
                        101.86000061035156,
                        126.48999786376953,
                        83.779998779296875,
                        81.449996948242188,
                        89.4800033569336,
                        106.19000244140625,
                        119.19999694824219,
                        138.97000122070312
                    ],
                    "varid": "pr",
                    "units": "mm",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        12.470000267028809,
                        14.270000457763672,
                        16.520000457763672,
                        18.0,
                        18.260000228881836,
                        16.530000686645508,
                        13.850000381469727,
                        11.0600004196167,
                        8.9399995803833
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        3.4200000762939453,
                        3.2599999904632568,
                        3.0699999332427979,
                        2.8299999237060547,
                        2.6400001049041748,
                        2.4500000476837158,
                        2.190000057220459,
                        2.309999942779541,
                        2.4100000858306885
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed",
                    "varGroup": "wind"
                }
            ],
            "forecastData": [
                {
                    "values": [
                        9.130000114440918,
                        -5.96999979019165,
                        -24.790000915527344,
                        -9.4799995422363281,
                        -11.229999542236328,
                        -14.659999847412109,
                        -2.1800000667572021,
                        12.970000267028809,
                        11.4399995803833
                    ],
                    "varid": "ped",
                    "units": "mm/month",
                    "name": "Potential Evapotranspiration Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        7.8600001335144043,
                        -4.4099998474121094,
                        -19.920000076293945,
                        -11.350000381469727,
                        -13.140000343322754,
                        -17.0,
                        -2.0199999809265137,
                        10.649999618530273,
                        8.5100002288818359
                    ],
                    "varid": "pr_p",
                    "units": "%",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        -0.30000001192092896,
                        -0.0099999997764825821,
                        -0.0099999997764825821,
                        0.18000000715255737,
                        0.85000002384185791,
                        0.93000000715255737,
                        0.5899999737739563,
                        0.68999999761581421,
                        0.33000001311302185
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature anomaly",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        1.0299999713897705,
                        0.70999997854232788,
                        0.4699999988079071,
                        0.039999999105930328,
                        0.079999998211860657,
                        0.37999999523162842,
                        0.27000001072883606,
                        0.18999999761581421,
                        0.31999999284744263
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed anomaly",
                    "varGroup": "wind"
                }
            ]
        },
        {
            "point": {
                "id": "db1d004a82e34d0082d55bb4805d9c33",
                "cid": "NZ",
                "lat": -38.497,
                "lon": 176.7136,
                "name": "New point"
            },
            "historicalData": [
                {
                    "values": [
                        95.4000015258789,
                        118.83000183105469,
                        136.69000244140625,
                        145.78999328613281,
                        113.27999877929688,
                        91.970001220703125,
                        53.290000915527344,
                        30.840000152587891,
                        19.209999084472656
                    ],
                    "varid": "ped",
                    "units": "mm",
                    "name": "Precipitation Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        110.37999725341797,
                        89.040000915527344,
                        127.63999938964844,
                        94.669998168945312,
                        90.610000610351562,
                        92.779998779296875,
                        111.80999755859375,
                        113.68000030517578,
                        130.74000549316406
                    ],
                    "varid": "pr",
                    "units": "mm",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        12.380000114440918,
                        14.359999656677246,
                        16.719999313354492,
                        18.149999618530273,
                        18.1200008392334,
                        16.260000228881836,
                        13.359999656677246,
                        10.449999809265137,
                        8.25
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        3.5499999523162842,
                        3.4600000381469727,
                        3.2699999809265137,
                        3.1800000667572021,
                        2.940000057220459,
                        2.75,
                        2.4500000476837158,
                        2.5299999713897705,
                        2.7000000476837158
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed",
                    "varGroup": "wind"
                }
            ],
            "forecastData": [
                {
                    "values": [
                        -1.809999942779541,
                        -14.3100004196167,
                        -28.319999694824219,
                        -9.0299997329711914,
                        -12.970000267028809,
                        -12.989999771118164,
                        2.7599999904632568,
                        8.8000001907348633,
                        -1.2300000190734863
                    ],
                    "varid": "ped",
                    "units": "mm/month",
                    "name": "Potential Evapotranspiration Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        0.10000000149011612,
                        -11.630000114440918,
                        -20.610000610351562,
                        -11.229999542236328,
                        -15.069999694824219,
                        -14.229999542236328,
                        3.0299999713897705,
                        7.4099998474121094,
                        -0.77999997138977051
                    ],
                    "varid": "pr_p",
                    "units": "%",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        -0.43999999761581421,
                        -0.27000001072883606,
                        0.05000000074505806,
                        0.090000003576278687,
                        0.72000002861022949,
                        0.79000002145767212,
                        0.46000000834465027,
                        0.57999998331069946,
                        0.30000001192092896
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature anomaly",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        0.79000002145767212,
                        0.62000000476837158,
                        0.31000000238418579,
                        0.039999999105930328,
                        0.11999999731779099,
                        0.38999998569488525,
                        0.25,
                        0.25999999046325684,
                        0.25999999046325684
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed anomaly",
                    "varGroup": "wind"
                }
            ]
        },
        {
            "point": {
                "id": "fae638c5d4db4afa9bf9685fd25f4499",
                "cid": "NZ",
                "lat": -37.3526,
                "lon": 174.9572,
                "name": "New point"
            },
            "historicalData": [
                {
                    "values": [
                        78.8499984741211,
                        99.05999755859375,
                        114.58999633789062,
                        123.09999847412109,
                        99.0199966430664,
                        84.339996337890625,
                        50.799999237060547,
                        29.719999313354492,
                        18.559999465942383
                    ],
                    "varid": "ped",
                    "units": "mm",
                    "name": "Precipitation Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        109.91999816894531,
                        98.360000610351562,
                        110.08999633789062,
                        87.8499984741211,
                        78.870002746582031,
                        91.199996948242188,
                        103.31999969482422,
                        128.85000610351562,
                        149.1300048828125
                    ],
                    "varid": "pr",
                    "units": "mm",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        13.050000190734863,
                        14.720000267028809,
                        16.840000152587891,
                        18.340000152587891,
                        18.719999313354492,
                        17.350000381469727,
                        14.899999618530273,
                        12.369999885559082,
                        10.340000152587891
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        3.2999999523162842,
                        3.1600000858306885,
                        2.9900000095367432,
                        2.6700000762939453,
                        2.5399999618530273,
                        2.4500000476837158,
                        2.2200000286102295,
                        2.2599999904632568,
                        2.3499999046325684
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed",
                    "varGroup": "wind"
                }
            ],
            "forecastData": [
                {
                    "values": [
                        19.709999084472656,
                        1.4500000476837158,
                        -26.049999237060547,
                        -10.869999885559082,
                        -16.6200008392334,
                        -12.460000038146973,
                        -3.9100000858306885,
                        6.0,
                        12.670000076293945
                    ],
                    "varid": "ped",
                    "units": "mm/month",
                    "name": "Potential Evapotranspiration Deficit",
                    "varGroup": "ped"
                },
                {
                    "values": [
                        19.739999771118164,
                        5.6999998092651367,
                        -24.430000305175781,
                        -12.590000152587891,
                        -20.020000457763672,
                        -15.220000267028809,
                        -4.6399998664855957,
                        4.8299999237060547,
                        9.4799995422363281
                    ],
                    "varid": "pr_p",
                    "units": "%",
                    "name": "Precipitation",
                    "varGroup": "precip"
                },
                {
                    "values": [
                        -0.33000001311302185,
                        -0.20000000298023224,
                        -0.51999998092651367,
                        -0.15999999642372131,
                        0.33000001311302185,
                        0.949999988079071,
                        0.68000000715255737,
                        0.75,
                        0.15000000596046448
                    ],
                    "varid": "t2m",
                    "units": "°C",
                    "name": "Temperature anomaly",
                    "varGroup": "temp"
                },
                {
                    "values": [
                        1.4500000476837158,
                        0.93999999761581421,
                        0.64999997615814209,
                        -0.0099999997764825821,
                        0.15000000596046448,
                        0.5899999737739563,
                        0.47999998927116394,
                        0.23999999463558197,
                        0.5
                    ],
                    "varid": "wind",
                    "units": "m/s",
                    "name": "Wind speed anomaly",
                    "varGroup": "wind"
                }
            ]
        }
    ],
    "forecast": {
        "country": {
            "centerX": 174.886,
            "centerY": -40.9006,
            "countryID": "NZ",
            "name": "New Zealand",
            "parentCountID": ""
        },
        "forecastID": "E1.201909",
        "pubDate": "2019-09-11"
    },
    "numMonths": 9*/
}

export { SampleReportData }